module.exports = __webpack_public_path__ + "static/linux-logo.674df11b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/linux-logo.svg
// module id = 204
// module chunks = 114276838955818 216277985284727